<div style="background: #ffeeff;" class="h-100 overflow-auto">
  <app-sidebar-header (close)="close.emit()" [title]="('integration' | translate) + ' Checkbox'"></app-sidebar-header>
  <mat-card class="shadow-none bg-transparent">
    <mat-card-content class="m-3 p-3 bg-white rounded-2">
      <div class="d-flex align-items-center gap-3">
        <img style="height: 150px; width: 150px" src="/assets/svgs/integrations/checkbox.svg" alt="Checkbox logo"/>
        <p>
          <span class="fw-bold">{{ 'integration' | translate }}:</span>
          <span class="text-success"> встановлена</span>
          ({{'exit'| translate}})
        </p>
      </div>

      <p class="my-2">1) Логін касира:</p>
      <div class="px-3">
        <app-text-field></app-text-field>
        <p class="my-2">Пароль касира:</p>
        <app-text-field></app-text-field>
        <p class="my-2">або<br>Пін-код касира</p>
        <app-text-field></app-text-field>
      </div>

      <p class="my-2">2) Ключ ліцензії каси:</p>
      <div class="px-3">
        <app-text-field></app-text-field>
        <app-button class="float-end my-2"><span>{{ 'save' | translate }}</span></app-button>
      </div>

    </mat-card-content>
    <mat-card-footer class="m-3 p-3 bg-white rounded-2 text-secondary">
      {{'integration_setup_is_very_simple_and_fast' | translate }}.
      {{'to_connect_your_cash_register' | translate}}.
    </mat-card-footer>
  </mat-card>
</div>
